// @deprecated use ButtonType instead
enum ButtonTypes {
    LARGE_POSITIVE = 'large-positive',
    LARGE_NEGATIVE = 'large-negative',
    STANDARD_POSITIVE = 'positive',
    STANDARD_NEGATIVE = 'negative',
    SMALL_POSITIVE = 'small-positive',
    SMALL_NEGATIVE = 'small-negative',
    LINK = 'link',
    LARGE_LINK = 'large-link',
    ACTION = 'action',
    ICON = 'icon',
    ICON_NEGATIVE = 'icon-dark',
    SMALL_ICON = 'small-icon',
}

export type ButtonType =
    | 'large-positive'
    | 'large-negative'
    | 'positive'
    | 'negative'
    | 'small-positive'
    | 'small-negative'
    | 'link'
    | 'large-link'
    | 'action'
    | 'icon'
    | 'icon-dark'
    | 'icon-negative'
    | 'small-icon';

export type StandardButtonTypes =
    | ButtonTypes.STANDARD_POSITIVE
    | ButtonTypes.STANDARD_NEGATIVE
    | ButtonTypes.LARGE_POSITIVE
    | ButtonTypes.LARGE_NEGATIVE
    | 'large-positive'
    | 'large-negative'
    | 'positive'
    | 'negative';

export type SmallButtonTypes =
    | ButtonTypes.SMALL_NEGATIVE
    | ButtonTypes.SMALL_POSITIVE
    | 'small-negative'
    | 'small-positive';

export type LinkButtonTypes = ButtonTypes.LINK | ButtonTypes.LARGE_LINK | 'link' | 'large-link';

export type IconButtonTypes =
    | ButtonTypes.ICON
    | ButtonTypes.ICON_NEGATIVE
    | ButtonTypes.SMALL_ICON
    | 'icon'
    | 'icon-dark'
    | 'icon-negative'
    | 'small-icon';

export default ButtonTypes;
